import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import image from "../../img/Home/image.webp"; // заглушка

function Video() {
  const { t, i18n } = useTranslation();
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true });
  const [videoSrc, setVideoSrc] = useState(null);

  const videosByLang = {
    ar: "https://compcoretech.com/videos/AR.MP4",
    bg: "https://compcoretech.com/videos/BR.MP4",
    de: "https://compcoretech.com/videos/DE.MP4",
    en: "https://compcoretech.com/videos/EN.MP4",
    es: "https://compcoretech.com/videos/ES.MP4",
    fr: "https://compcoretech.com/videos/FR.MP4",
    it: "https://compcoretech.com/videos/IT.MP4",
    pl: "https://compcoretech.com/videos/PL.MP4",
    ru: "https://compcoretech.com/videos/RU.MP4",
    ua: "https://compcoretech.com/videos/UA.MP4",
    zh: "https://compcoretech.com/videos/CH.MP4",
  };

  useEffect(() => {
    const currentLang = i18n.language?.split("-")[0] || "en";
    setVideoSrc(videosByLang[currentLang] || null);
  }, [i18n.language]);

  useEffect(() => {
    if (inView) {
      controls.start({
        opacity: 1,
        clipPath: "inset(0% 0% 0% 0%)",
        transition: { duration: 1, ease: "easeOut" },
      });
    }
  }, [inView, controls]);

  return (
    <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
      <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
        {/* Текст */}
        <div className="xl:hidden flex flex-col md:flex-row md:gap-[20px]">
          <p className="open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px]">
            {t("home.3")}
          </p>
          <p className="open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] mt-[14px] md:mt-0">
            {t("home.4")}
          </p>
        </div>

        {/* Видео / Заглушка */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, clipPath: "inset(0% 50% 0% 50%)" }}
          animate={controls}
          className="relative pt-[100px] xl:pt-0"
        >
          {videoSrc ? (
            <video
              key={videoSrc} // чтобы обновлялось при смене языка
              autoPlay
              muted
              controls
              playsInline
              src={videoSrc}
              className="w-full rounded-2xl"
              onError={() => setVideoSrc(null)} // если файл не найден — fallback
            />
          ) : (
            <img
              src={image}
              alt="Video placeholder"
              className="w-full rounded-2xl"
            />
          )}
        </motion.div>
      </div>
    </div>
  );
}

export default Video;
